import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

export interface ForecastDuplicatedWizardScreenProps {
  onClose: () => void;
  onView: () => void;
}

export const ForecastDuplicatedWizardScreen = ({ onClose, onView }: ForecastDuplicatedWizardScreenProps) => {
  const intl = useIntl();

  const viewText = intl.formatMessage({
    id: 'predict.forecasting.go_to_forecast',
    defaultMessage: 'Go to forecast'
  });

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose} onView={onView} viewText={viewText}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'predict.forecasting.forecast_duplicated_and_saved_as_a_draft',
          defaultMessage: 'Forecast duplicated and saved as a draft for review'
        })}
      />
    </WizardScreen>
  );
};
